export const getEnv = (key) => import.meta.env[key];